import _ from 'lodash';
import { Model } from 'backbone';
import validate from 'validate.js';
import { contactRules } from '../../validation_rules';
import { SaveMultipartFormData } from '../../utils';

const saveMultipartFormData = new SaveMultipartFormData();

/**
 * This is League Model Class
 */
export default class ContactUsModel extends Model {
	/**
	 * Set default model fields
	 * @returns object
	 */
	defaults() {
		return {
			'name':       '',
			'email':      '',
			'question':   '',
			'category':   '',
			'categories': {
				'Errors':                     'Errors',
				'My Account & Subscriptions': 'My Account & Subscriptions',
				"Password and logging in":    'Password, Logging In & Linking Accounts',
				'Finals and playoffs':        'Finals and Playoffs',
				'Assistant Coach':            'Coach',
				'Gameplay questions':         'Gameplay Questions',
				'Team management':            'Team Management'
			},
			'errors':     {}
		}
	}

	/**
	 * Validate current league data
	 * @returns {ContactUsModel}
	 */
	validateForm() {
		let errors = validate(
			this.toJSON(),
			contactRules
		);

		this.set( 'errors', errors );

		if ( !_.isUndefined( errors ) ) {
			this.trigger( 'contact:us:update:form:errors', errors );
		}
		else {
			this.trigger( 'contact:us:update:form:success' );
		}

		return this;
	}

	sendContactData() {
		const url  = 'contact';
		const data = {
			url,
			formData: this.toJSON()
		};

		saveMultipartFormData
			.save( data )
			.then( response => {
				if ( response.errors.length ) {
					this.trigger( 'contact:send:errors', response.errors );
				}
				else {
					this.set( response.result );
					this.trigger( 'contact:send:success', response );
				}
			} );

		return this;
	}

	clearData() {
		this.set({
			'name':       '',
			'email':      '',
			'question':   '',
			'category':   ''
		});
	}

}